
import React from "react";
import { Helmet } from "react-helmet-async";

interface GoogleVerificationProps {
  verificationId?: string;
}

const GoogleVerification: React.FC<GoogleVerificationProps> = ({
  verificationId = "G-MYPETID-VERIFICATION-12345",
}) => {
  return (
    <Helmet>
      <meta name="google-site-verification" content={verificationId} />
    </Helmet>
  );
};

export default GoogleVerification;
